export default __webpack_public_path__ + "static/media/placeholder-image.409e3996.jpg";